export default "__VITE_ASSET__cbd0db24__"